export interface IAuthService {
  sendUserToUnauthenticatedComponent(): void;

  getAuthServerLoginUrl(tenant: string): string;

  sendUserToAuthServerLogin(tenant: string): void;

  getAuthServerLogoutUrl(): string;

  sendUserToAuthServerLogout(): void;

  clearTokensAndUserInfo(): void;

  currentUserIsAuthenticated(): boolean;

  getAccessToken(): string;

  setAccessToken(accessToken: string): void;

  getIdToken(): string;

  setIdToken(idToken: string): void;

  getAccessTokenExpires(): Date;

  setAccessTokenExpires(dte: Date): void;

  getTenant(): string;

  setTenant(tenant: string): void;

  hasAuthenticationTokensInUrl(): boolean;

  extractAuthenticationTokensFromUrl(): void;

  getUserInfo(): any;

  setUserInfo(userInfo: any): void;
}
